export const appRoutes = {
  ABOUT: "/login",
  PRIVACY: "/privacy",
  GUIDELINES: "/guidelines",
  CONTACT: "/contact",
  TNC: "/tnc",
  FEATURES: "/#ourFeatures",
  LOGIN: "/login",
  FEEDBACK: "/feedback"
};
